import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import {
  actions as salesIntelligenceActions,
  selectors as salesIntelligenceSelectors,
} from 'state/salesIntelligence';

import RecurringOrderSuggestionsModal from 'components/RecurringOrderSuggestionsModal/component';

const enhance = compose(
  withTranslation('RecurringOrderSuggestions'),
  connect(
    (state) => ({
      suggestion: salesIntelligenceSelectors.getRecurringOrderSuggestion(state),
    }),
    {
      closeRecurringOrderSuggestionsModal:
        salesIntelligenceActions.closeRecurringOrderSuggestionsModal,
      openRecurringOrderSuggestionsDiscardReasonsModal:
        salesIntelligenceActions.openRecurringOrderSuggestionsDiscardReasonsModal,
      acceptRecurringOrderSuggestionModal:
        salesIntelligenceActions.acceptRecurringOrderSuggestion,
    }
  ),
  withHandlers(() => ({
    handleClose:
      ({
        closeRecurringOrderSuggestionsModal,
        openRecurringOrderSuggestionsDiscardReasonsModal,
      }) =>
      () => {
        closeRecurringOrderSuggestionsModal();
        openRecurringOrderSuggestionsDiscardReasonsModal();
      },
    handleAccept:
      ({ acceptRecurringOrderSuggestionModal }) =>
      () => {
        acceptRecurringOrderSuggestionModal();
      },
  }))
);

export default enhance(RecurringOrderSuggestionsModal);
